import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import mobx from 'mobx';
import { Link } from 'react-router';
import {observer} from 'mobx-react';



import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import PageLoading from '../components/PageLoading';
import { Chart } from 'react-google-charts';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Toggle from 'material-ui/Toggle';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { Toolbar, ToolbarGroup } from 'material-ui';

import GoogleMap from '../components/GoogleMap';
import moment from 'moment';


const formStyle = {
  marginLeft: 24,
  marginRight: 24,
};

const spacing = {
  marginTop: 24
}

const lastUpdated = {
  position: 'absolute', 
  left: 'calc(50% + 128px)', 
  transform: 'translate(-50%,0)', 
  textShadow: '0 0 4px #000000', 
  textAlign: 'center', 
  marginTop: '-24px', 
  color: 'white'
}

export default
@observer class SimCardDetailPage extends Component {

  constructor(props){
    super(props)

    this.state = {
      customer: null,
      machines: []
    }
  }

  static contextTypes = {
    router: React.PropTypes.object
  }
  componentWillMount(){
    if(AppModel.simCardForm.simCard.name == null){
      this.context.router.push(`/simcards`);
    }
    if(AppModel.simCardForm.simCard.customerId != null){
      this.loadMachines(AppModel.simCardForm.simCard.customerId)
    }
  }

  loadMachines(customer_id) {
    AppModelUtils.fetch_machinelist_for({ id: customer_id })
    .then(machines => {      
      this.setState({ machines: machines, customer: customer_id })
    });
  
  }

  createChart(){    
    return (
        <Chart
          style={spacing}
          chartType="Bar"
          data={[[ uiMsg('SCD_MONTH',"Month"), "MB"], ...mobx.toJS(AppModel.simCardUsage)]}
          width="100%"
          height="400px"
          loader={<div>Loading charts</div>}
          legendToggle={false}
          options={{
            colors: ['#6491a0'],
            chart: {
              title: uiMsg('SCD_DATA_USAGE',"Data usage"),
            },
          }}
        />
    )
  }
  updateActiveSelectField() {
    let self = this;
    return function(e, key, customer_id) {
      self.loadMachines(customer_id)
    }
  }
  // Helper method that writes values back to datamodel as fields are changed
  updateSelectField(form, key) {   
    return function(e, k, payload) {
      form[key] = payload;
    }
  }
  updateToggle(form, key) {
    return function(e, value){
      form[key] = value;
    }
  }

  updateSimCard = () => {
    let form = AppModel.simCardForm;

    AppModelUtils.updateSimCard(AppModel.simCardForm)
    AppModel.simCardForm.reset()
  }

  cancel = () => {
    this.context.router.push(`/simcards`);
  }

  render() {
    let totalArray = AppModel.simCardUsage.map(point => {
      return point[1]
    })
    let form = AppModel.simCardForm;
    let sim = form.simCard;
    
    let locationData = AppModel.simCardLocationData;
    let location = locationData ? locationData.geo : null;
    let lat = location ? Number(location.lat) : 0;
    let lng = location ? Number(location.lng) : 0;
    let date = locationData ? locationData.date : 0;
    
    return (
      <PageLoading loading={AppModel.fetchingSimCardDetails || AppModel.customerListLoading}>
            { location ? (
              <div>
                <GoogleMap center={{lat: lat, lng: lng}} markerText={sim.name} style={{zIndex: 0}}/> 
                <h4 style={lastUpdated}>{uiMsg("SCD_LOCATION_UPDATE", "Location last updated:")} {moment(new Date(date)).format('LLL')}</h4>
              </div>
            ) : null }
            <div style={formStyle}>  
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginTop: 24}}>
                <h1 style={{width: '50%'}}>{sim.name}</h1>
                <h4>{`ICCID: ${sim.iccid}`}</h4>
              </div>
              

              {AppModel.simCardUsage.length > 0 ? 
                <div>
                  {this.createChart()} 
                  <h4 style={spacing}>{uiMsg("SCD_TOTAL_USAGE", "Total last x months: y MB", totalArray.length, totalArray.length > 0 ? totalArray.reduce((a, c) => a + c) : 0)}</h4>
                </div>
              : null}

              <SelectField
                style={spacing}
                data-propname="customer"
                floatingLabelText={uiMsg('CUSTOMER',"Customer")}
                value={this.state.customer || sim.customerId || ''}
                onChange={this.updateActiveSelectField()}
                fullWidth={true}
              >
                {AppModel.customerListIncludingOwnCompany.map(c => {                  
                  return (
                    <MenuItem key={c.id} value={c.id} primaryText={c.name} />
                  )
                })}
              </SelectField>
              <SelectField
                data-propname="newMachineId"
                floatingLabelText={uiMsg('MACHINE',"Machine")}
                value={form.newMachineId || sim.machineId}
                onChange={this.updateSelectField(form, 'newMachineId')}
                fullWidth={true}
              >
                {this.state.machines.map(m => {                  
                  return (
                    <MenuItem key={m.id} value={m.id} primaryText={m.name || m.id} />
                  )
                })}
              </SelectField>
              <SelectField
                style={spacing}
                data-propname="data"
                floatingLabelText={uiMsg('SCD_DATA_PACKAGE',"Data package")}
                value={form.newDataPackage || sim.dataId}
                onChange={this.updateSelectField(form, 'newDataPackage')}
                disabled={sim.status != 'reserved'}
                fullWidth={true}
              >
                {AppModel.dataSubscriptions.map(sub => {
                  return (
                    <MenuItem key={sub.id} value={sub.id} primaryText={sub.description} />
                  )
                })}
              </SelectField>
              
              {AppModel.smsSubscriptions.length>0 ? (
              <SelectField
                data-propname="sms"
                floatingLabelText={uiMsg('SCD_SMS_PACKAGE',"SMS package")}
                value={form.newSMSPackage || sim.smsId}
                onChange={this.updateSelectField(form, 'newSMSPackage')}
                disabled={sim.status != 'reserved'}
                fullWidth={true}
              >
                {AppModel.smsSubscriptions.map(sub => {
                  return (
                    <MenuItem key={sub.id} value={sub.id} primaryText={sub.description} />
                  )
                })}
              </SelectField>
              ) : null }
              { sim.status != 'reserved' ? <h5 style={{fontWeight: 'normal'}}>{uiMsg("SCD_API_LIMIT_DESC", "Data package and SMS package can only be changed in the COM4 portal when SIM card is activated")}</h5> : null}
              
              <Toggle style={spacing} label={uiMsg('SCD_ROAMING',"Roaming")} onToggle={this.updateToggle(form, 'newRoaming')} toggled={form.newRoaming || AppModel.roamingStatus || false} disabled={AppModel.roamingStatus == null}/>
            
            
              <Toggle style={spacing} label={uiMsg('SCD_FREEZE',"Freeze")} onToggle={this.updateToggle(form, 'newFreeze')} toggled={form.newFreeze || sim.freezed}/>

              
            </div>     
            <Toolbar style={{marginTop: 24, marginBottom: 100}}>
              <ToolbarGroup firstChild={true}></ToolbarGroup>
              <ToolbarGroup lastChild={true}>
                <FlatButton onTouchTap={this.cancel}>
                        {uiMsg("SCD_CANCEL", "Cancel")}
                </FlatButton>
                <RaisedButton primary
                              disabled={form.newDataPackage == null && form.newSMSPackage == null && form.newMachineId == null && form.newFreeze == null && form.newRoaming == null}
                              onTouchTap={this.updateSimCard}>
                              {uiMsg("SCD_UPDATE", "Update")}
                </RaisedButton>
              </ToolbarGroup>
            </Toolbar>   
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/SimCardDetailPage.jsx
 **/